import { useTranslation } from 'react-i18next';
import type { SettingsParamsType } from '@econtractor/types';
import ParamSwitch from '../ParamSwitch';

type TasksTabProps = {
    params: SettingsParamsType;
    isSaving: boolean;
    setParam: <K extends keyof SettingsParamsType>(key: K, value: SettingsParamsType[K]) => void;
};

const TasksTab = ({ params, isSaving, setParam }: TasksTabProps) => {
    const { t } = useTranslation(['Settings']);

    return (
        <div className="main-settings-fields">
            <ParamSwitch
                id="param-tasksModule"
                label={t('mainParams.fields.tasksModule.label')}
                description={t('mainParams.fields.tasksModule.description')}
                checked={params.tasksModule}
                disabled={isSaving}
                onChange={(v) => setParam('tasksModule', v)}
            />
            <div className="border-top">
                <ParamSwitch
                    id="param-tasksAutoAcceptOwn"
                    label={t('mainParams.fields.tasksAutoAcceptOwn.label')}
                    description={t('mainParams.fields.tasksAutoAcceptOwn.description')}
                    checked={params.tasksAutoAcceptOwn}
                    disabled={isSaving || !params.tasksModule}
                    onChange={(v) => setParam('tasksAutoAcceptOwn', v)}
                />
            </div>
            <div className="border-top">
                <ParamSwitch
                    id="param-tasksForLeads"
                    label={t('mainParams.fields.tasksForLeads.label')}
                    description={t('mainParams.fields.tasksForLeads.description')}
                    checked={params.tasksForLeads}
                    disabled={isSaving || !params.tasksModule}
                    onChange={(v) => setParam('tasksForLeads', v)}
                />
            </div>
            <div className="border-top">
                <ParamSwitch
                    id="param-tasksForObjects"
                    label={t('mainParams.fields.tasksForObjects.label')}
                    description={t('mainParams.fields.tasksForObjects.description')}
                    checked={params.tasksForObjects}
                    disabled={isSaving || !params.tasksModule}
                    onChange={(v) => setParam('tasksForObjects', v)}
                />
            </div>
        </div>
    );
};

export default TasksTab;
